// Stores
import useToastStore, { AddToastProps } from "../../components/Toast/Store";

type HookResponse = (message: string, options?: Omit<AddToastProps, "message">) => void;

/**
 *
 * @deprecated use newer py-components toast
 */
const useToast = (): HookResponse => {
	const [addToast] = useToastStore((state) => [state.addToast]);

	const toast = (message: string, options?: Omit<AddToastProps, "message">) => {
		addToast({
			message,
			type: "success",
			duration: 2000,
			...options,
		});
	};

	return toast;
};

export default useToast;
